<div class="sidebar-wrapper" 
     [class.collapsed]="isCollapsed && isCollapsible"
     [class.simple-mode]="!isCollapsible"
     [class.collapsible-mode]="isCollapsible"
     *ngIf="hasData">

  <!-- SIMPLE MODE -->
  <ng-container *ngIf="!isCollapsible">
    <div class="sidebar-simple">
      <label class="font-semibold text-lg" *ngIf="title">{{title}}</label>
      
      <!-- Simple Flat List -->
      <ul class="list-items" *ngIf="!isGrouped">
        <li 
          *ngFor="let item of flatListData"
          class="cursor {{isSelected(item) ? 'current-cc' : 'no-bg'}}"
          (click)="onItemSelect(item)">
          <ng-container 
            *ngTemplateOutlet="itemTemplate; context: { $implicit: item, selectedName: selectedName, company: company }">
          </ng-container>
          <span *ngIf="!itemTemplate" class="sidebar-item-text">
            {{ getDisplayName(item) }}
          </span>
        </li>
      </ul>

      <!-- Simple Grouped List -->
      <ul class="p-2" *ngIf="isGrouped">
        <ng-container *ngFor="let group of groupListData">
          <ng-container 
            *ngTemplateOutlet="itemTemplate; context: { $implicit: group, selectedGroupItem: selectedGroupItem }">
          </ng-container>
          <span *ngIf="!itemTemplate" class="sidebar-item-text">
            {{ getDisplayName(group) }}
          </span>
        </ng-container>
      </ul>
    </div>
  </ng-container>

  <!-- COLLAPSIBLE MODE -->
  <ng-container *ngIf="isCollapsible">
    
    <!-- Collapsible Flat List (Quarters) -->
    <ng-container *ngIf="!isGrouped">
      <p-panel [toggleable]="true" [collapsed]="isCollapsed">
        <ng-template pTemplate="header">
          <h2 class="m-0">{{ title }}</h2>
        </ng-template>
        <ul class="list-items m-0">
          <li 
            *ngFor="let item of flatListData"
            class="cursor-pointer quarter-list {{isSelected(item) ? 'active' : ''}}"
            (click)="onItemSelect(item)">
            <ng-container 
              *ngTemplateOutlet="itemTemplate; context: { $implicit: item, selectedName: selectedName, company: company }">
            </ng-container>
            <span *ngIf="!itemTemplate" class="sidebar-item-text">
              {{ getDisplayName(item) }}
            </span>
          </li>
        </ul>
      </p-panel>
    </ng-container>

    <!-- Collapsible Grouped List (Companies - NESTED PANELS) -->
    <ng-container *ngIf="isGrouped">
      <ul class="p-2" *ngIf="groupListData.length > 0; else noItems">
        <ng-container *ngFor="let group of groupListData">
          <!-- Multiple members → Collapsible p-panel -->
          <p-panel 
            *ngIf="hasGroupMembers(group); else singleMemberGroup"
            [toggleable]="true" 
            [collapsed]="groupCollapseState[getGroupKey(group)] ?? true"
            (onCollapse)="groupCollapseState[getGroupKey(group)] = true"
            (onExpand)="groupCollapseState[getGroupKey(group)] = false">
            
            <ng-template pTemplate="header">
              <span>
                <h3 class="m-0"><strong>{{ getDisplayName(group) }}</strong></h3>
              </span>
            </ng-template>
            
            <ul class="list-items m-0">
              <li 
                *ngFor="let member of getGroupMembers(group)"
                class="cursor-pointer"
                (click)="onItemSelect(member)"
                (keydown.enter)="onItemSelect(member)">
                <a [class.active]="isSelected(member)">{{ getDisplayName(member) }}</a>
              </li>
            </ul>
          </p-panel>
          
          <!-- Single member group -->
          <ng-template #singleMemberGroup>
            <div class="border-bottom-1 surface-border no-members p-2">
              <h3 
                class="cursor m-0" 
                [class.active]="isSelected(group)"
                (click)="onItemSelect(group)"
                (keydown.enter)="onItemSelect(group)">
                <strong>{{ getDisplayName(group) }}</strong>
              </h3>
            </div>
          </ng-template>
        </ng-container>
      </ul>
      
      <ng-template #noItems>
        <div class="border-bottom-1 surface-border no-members p-2">
          <span>No items found</span>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
</div>
